<template>
  <Transition name="modal">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      @click.self="closeModal"
    >
      <div
        class="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden"
        @click.stop
      >
        <!-- Header -->
        <div class="flex items-center justify-between p-6 border-b border-neutral-200">
          <h2 class="text-xl font-semibold text-neutral-900">CV Preview</h2>
          <div class="flex items-center gap-3">
            <button
              @click="downloadCV"
              class="inline-flex items-center gap-2 rounded-md bg-neutral-900 text-white px-4 py-2 ring-1 ring-neutral-900/10 hover:bg-neutral-800 transition"
            >
              <Download :size="18" />
              <span>Download</span>
            </button>
            <button
              @click="closeModal"
              class="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-neutral-100 text-neutral-600 hover:text-neutral-900 transition"
            >
              <X :size="20" />
            </button>
          </div>
        </div>

        <!-- PDF Preview -->
        <div class="flex-1 overflow-auto cv-preview-container">
          <iframe
            :src="cvUrl"
            class="w-full border-0 cv-preview-iframe"
            style="min-height: 600px; display: block;"
            scrolling="auto"
          ></iframe>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { Download, X } from 'lucide-vue-next'

export default {
  name: 'CVPreviewModal',
  components: {
    Download,
    X
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    cvUrl: {
      type: String,
      required: true
    },
    cvDownloadUrl: {
      type: String,
      required: true
    }
  },
  emits: ['close'],
  watch: {
    isOpen(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
      document.body.style.overflow = ''
    },
    downloadCV() {
      const link = document.createElement('a')
      link.href = this.cvDownloadUrl
      link.download = 'CV.pdf'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active > div,
.modal-leave-active > div {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from > div,
.modal-leave-to > div {
  opacity: 0;
  transform: scale(0.95);
}

/* Smooth scrolling for CV preview */
.cv-preview-container {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.cv-preview-iframe {
  scroll-behavior: smooth;
}
</style>

